import { Component, PropsWithChildren } from 'react';
import { inject, observer } from 'mobx-react';
import { Route, Routes } from 'react-router';
import BasicLayout from '../layout/basic/BasicLayout';
import { AppStore } from '../store';
import RedirectToRouteComponent from './RedirectToRouteComponent';
import { getAuth0Path } from './postLogin.utils';

interface IConnectRouterProps {
    routes: any[];
    app?: AppStore;
}

@observer
class ConnectRouter extends Component<PropsWithChildren<IConnectRouterProps>> {
    render() {
        const { routes, app } = this.props;
        const routesCmp = routes.map((route, index) => {
            const { Component, isSecured, role: allowedRoles, config } = route;
            const Layout = route.Layout ? route.Layout : BasicLayout;
            let isAllowed = true;
            if (isSecured) {
                isAllowed = (app as AppStore).isAuthenticated;
                if (isAllowed && allowedRoles) {
                    isAllowed = allowedRoles.some(role => (app as AppStore).token.hasRole(role));
                }
            }
            return isAllowed ? (
                <Route
                    key={index}
                    path={route.path}
                    element={
                        <Layout {...config}>
                            <Component {...config} />
                        </Layout>
                    }
                />
            ) : (
                <Route key={index} path={route.path} element={<RedirectToRouteComponent to={getAuth0Path()} />} />
            );
        });
        return <Routes>{routesCmp}</Routes>;
    }
}

export default inject('app')(ConnectRouter);
